import moment from 'moment';
import React from 'react';
import {i18n} from 'src/i18n';
import ActivoViewItem from 'src/view/activo/view/ActivoViewItem';
import CodificacionISOViewItem from 'src/view/codificacionISO/view/CodificacionISOViewItem';
import DocumentCategoryViewItem from 'src/view/documentCategory/view/DocumentCategoryViewItem';
import DocumentosRelacionadosView from 'src/view/gestorDocumental/view/DocumentosRelacionadosView';
import GestorDocumentalViewItem from 'src/view/gestorDocumental/view/GestorDocumentalViewItem';
import PerfilEmpleadoViewItem from 'src/view/perfilEmpleado/view/PerfilEmpleadoViewItem';
import RecordatorioViewItem from 'src/view/recordatorio/view/RecordatorioViewItem';
import RegistroViewItem from 'src/view/registro/view/RegistroViewItem';
import Spinner from 'src/view/shared/Spinner';
import FilesViewItem from 'src/view/shared/view/FilesViewItem';
import ImagesViewItem from 'src/view/shared/view/ImagesViewItem';
import TextViewItem from 'src/view/shared/view/TextViewItem';

function GestorDocumentalView(props) {
  const renderView = () => {
    const {record} = props;

    return (
      <div>
        {/* Componente para visualizar documentos relacionados */}
        <DocumentosRelacionadosView documentoId={record.id} />

        <FilesViewItem label={i18n('entities.gestorDocumental.fields.documentosAdjuntos')} value={record.documentosAdjuntos} />

        <ImagesViewItem label={i18n('entities.gestorDocumental.fields.fotosAdjuntas')} value={record.fotosAdjuntas} />

        <TextViewItem
          label={i18n('entities.gestorDocumental.fields.garantia')}
          value={record.garantia ? i18n('common.yes') : i18n('common.no')}
        />

        <GestorDocumentalViewItem
          label={i18n('entities.gestorDocumental.fields.documentoPrincipal')}
          value={record.documentoPrincipal}
        />

        <DocumentCategoryViewItem
          label={i18n('entities.gestorDocumental.fields.documentCategory')}
          value={record.documentCategory}
        />

        <TextViewItem label={i18n('entities.gestorDocumental.fields.nombre')} value={record.nombre} />

        <TextViewItem label={i18n('entities.gestorDocumental.fields.descripcion')} value={record.descripcion} />

        <TextViewItem
          label={i18n('entities.gestorDocumental.fields.tipoDocumento')}
          value={record.tipoDocumento && i18n(`entities.gestorDocumental.enumerators.tipoDocumento.${record.tipoDocumento}`)}
        />

        <TextViewItem label={i18n('entities.gestorDocumental.fields.version')} value={record.version} />

        <TextViewItem
          label={i18n('entities.gestorDocumental.fields.validoDesde')}
          value={record.validoDesde ? moment(record.validoDesde).format('DD-MM-YYYY') : null}
        />

        <TextViewItem
          label={i18n('entities.gestorDocumental.fields.validoHasta')}
          value={record.validoHasta ? moment(record.validoHasta).format('DD-MM-YYYY') : null}
        />

        <RecordatorioViewItem label={i18n('entities.gestorDocumental.fields.recordatorios')} value={record.recordatorios} />

        <CodificacionISOViewItem label={i18n('entities.gestorDocumental.fields.codigoISO')} value={record.codigoISO} />

        <TextViewItem label={i18n('entities.gestorDocumental.fields.autor')} value={record.autor} />

        <PerfilEmpleadoViewItem
          label={i18n('entities.gestorDocumental.fields.perfilesEmpleados')}
          value={record.perfilesEmpleados}
        />

        <ActivoViewItem label={i18n('entities.gestorDocumental.fields.activosVinculados')} value={record.activosVinculados} />

        <RegistroViewItem label={i18n('entities.gestorDocumental.fields.registros')} value={record.registros} />
      </div>
    );
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default GestorDocumentalView;
